import { Getters } from '@/shared/app/model/store/getters';

export function readActiveDishes(getters: Getters, datasets: string[], maxDishes = 20) {
  const actives: { [dataset: string]: number[] } = {};
  if (!getters.all) return {};
  datasets.forEach((dataset) => {
    const values = getters.all(dataset);
    actives[dataset] = [];
    for (let i = 1; i <= maxDishes; i += 1)
      if (values[`dish${i}_enable`] === true) actives[dataset].push(i);
  });
  return actives;
}
